import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {APIError} from 'data/errors/api-error';
import {
	GetRequestPreviewProtocolPdf,
	GetRequestPreviewProtocolPdfModel,
	GetRequestPreviewProtocolPdfParams,
} from 'domain/usecases';

export class RemoteGetRequestPreviewProtocolPdf implements GetRequestPreviewProtocolPdf {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<GetRequestPreviewProtocolPdfModel>,
	) {}

	async get(
		params: GetRequestPreviewProtocolPdfParams,
		signal?: AbortSignal,
	): Promise<GetRequestPreviewProtocolPdfModel> {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'get',
			params,
			signal,
		});

		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
